import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { oltAPI } from '../../services/api';
import { LoadingBlock, EmptyState } from '../../components/technical/TechnicalUI';
import { Router, ChevronRight, ArrowLeft } from 'lucide-react';
import useDarkReady from '../../theme/useDarkReady';

// Only one OLT is configured on this deployment (single OLTConfig doc, see oltService) —
// this still renders as a list (of one) rather than hardcoding a single-item page, so it
// scales cleanly if a second OLT is ever added.
export default function TechnicalOltStatusPage() {
  useDarkReady();
  const navigate = useNavigate();
  const [status, setStatus] = useState(null);
  const [ports, setPorts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([oltAPI.getStatus(), oltAPI.getPorts().catch(() => ({ data: { data: [] } }))])
      .then(([s, p]) => { setStatus(s.data); setPorts(p.data.data || []); })
      .catch(() => setStatus({ configured: false }))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <LoadingBlock />;
  if (!status?.configured) return <EmptyState icon={Router} text="No OLT configured — set it up in Settings > OLT" />;

  const totalOnus = ports.reduce((a, p) => a + p.totalOnus, 0);
  const onlineOnus = ports.reduce((a, p) => a + p.onlineOnus, 0);
  const online = !!status.data;
  const d = status.data || {};

  return (
    <div>
      <button onClick={() => navigate(-1)} style={{ display: 'flex', alignItems: 'center', gap: 6, background: 'none', border: 'none', color: 'var(--text-muted)', fontSize: '.85rem', cursor: 'pointer', padding: 0, marginBottom: 14 }}>
        <ArrowLeft size={16} /> Back
      </button>
      <div className="page-header">
        <h2>OLT Status</h2>
        <p style={{ color: 'var(--text-muted)', fontSize: '.85rem' }}>{ports.length} PON ports · {totalOnus} ONUs</p>
      </div>

      <Link to="/technical/olt-status/detail" style={{ textDecoration: 'none', color: 'inherit' }}>
        <div className="stat-card" style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          <div style={{
            width: 10, height: 10, borderRadius: '50%', flexShrink: 0,
            background: online ? 'var(--cb-0ca30c)' : 'var(--cb-d03b3b)',
          }} />
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontWeight: 700 }}>{d.hostname || 'OLT'}</div>
            <div style={{ fontSize: '.78rem', color: 'var(--text-muted)' }}>{d.model || '—'}</div>
            <div style={{ display: 'flex', gap: 14, marginTop: 6, fontSize: '.78rem', color: 'var(--text-muted)' }}>
              <span>CPU {d.cpuUsage || '—'}</span>
              <span>Mem {d.memoryUsage || '—'}</span>
              <span>{onlineOnus}/{totalOnus} ONUs</span>
            </div>
          </div>
          <ChevronRight size={18} color="var(--text-muted)" />
        </div>
      </Link>
    </div>
  );
}
